import { injectAesthetic } from './shared-styles.ts';

export class AppCard extends HTMLElement {
    static get observedAttributes() {
        return ['variant', 'interactive', 'padding'];
    }

    private seed: number;

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.seed = Math.floor(Math.random() * 10000);
    }

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            this.render();
        }
    }

    render() {
        if (!this.shadowRoot) return;

        const variant = this.getAttribute('variant') || 'default';
        const interactive = this.hasAttribute('interactive');
        const padding = this.getAttribute('padding') || 'md';

        this.shadowRoot.innerHTML = `
            ${injectAesthetic(this.seed)}
            <style>
                :host {
                    display: block;
                    height: 100%;
                    --border: var(--border);
                }

                .card {
                    background: var(--bg-card);
                    border: 1px solid var(--border);
                    border-radius: var(--radius-lg);
                    height: 100%;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                }

                /* Paddings */
                .card.p-none { padding: 0; }
                .card.p-sm { padding: 1rem; }
                .card.p-md { padding: 1.5rem; }
                .card.p-lg { padding: 2rem; }

                /* Variants */
                .card.outlined {
                    background: transparent;
                    border: 1.5px dashed var(--border-sketch);
                }
                
                .card.outlined::before,
                .card.outlined::after {
                    display: none;
                }
                
                .card.glass {
                    background: rgba(255, 255, 255, 0.01);
                    backdrop-filter: blur(10px);
                }

                ::slotted(*) {
                   position: relative;
                   z-index: 2;
                }
            </style>
            <div class="card ${variant} ${interactive ? 'interactive sketch-base shadow-industrial' : 'sketch-base shadow-industrial'} p-${padding}">
                <slot></slot>
            </div>
        `;
    }
}

customElements.define('app-card', AppCard);
